import { render, staticRenderFns } from "./stock_record_list.vue?vue&type=template&id=751c22ce&scoped=true"
import script from "./stock_record_list.vue?vue&type=script&lang=js"
export * from "./stock_record_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c22ce",
  null
  
)

export default component.exports